import { Component, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonService } from '../../shared/common/common.service';
// import { AddDependentRoutingModule } from "../../feature-module/patients/dependent/add-dependent/add-dependent-routing.module";
import { SharedModule } from '../../shared/shared.module';
import { NgClass } from '@angular/common';
import { CommonStandaloneImports } from '../../shared/common/common-standalone-imports';

@Component({
  selector: 'app-terms-condition',
  imports: [NgClass,SharedModule,...CommonStandaloneImports],
  standalone: true,
  templateUrl: './terms-condition.html',
  styleUrl: './terms-condition.scss',
})
export class TermsConditionComponent {
  constructor(
    public commonService:CommonService
  ) {}
  show: boolean = false;

  ngOnInit(): void {
    setTimeout(() => {
      this.show = true;
    }, 0);
  }

  close(): void {
    // this.dialogRef.close();
  }
}
